import React from "react";
import { getDegree, getVelocity, formatHourPmAm } from "helpers";
import { Container, Slides } from "./style";
import Slider from "@/shared/Slider";
import ContentIcon from "@/shared/ContentIcon";

export const WeatherCityHour = ({
  weathers,
  pathIcon,
  selectTemp,
  selectVelocity,
}) => {
  
    const slides = weathers.map((data, index) => {
    const arrayWind = data.wind.split(" ");
    const formattedHour = formatHourPmAm(data.hour);

    return (
      <Slides className="slide" key={`hours${index}`}>
        <div className="hoursRows head">
          <div className="hoursData data-head">
            <p className="hours">{formattedHour}</p>
          </div>
        </div>

        <div className="hoursRows">
          <div className="hoursData conditions">
            <p>{data.conditions}</p>
          </div>
        </div>
        <div className="hoursRows">
          <div className="hoursData data">
            <picture>
              <img width="30" height="30" src={pathIcon(data.icon)} alt={data.conditions} />
            </picture>
          </div>
        </div>
        <div className="hoursRows">
          <div className="hoursData">
            <p className="degree-size">
              <span>TEMPERATURA</span>
              {getDegree(data.temp, selectTemp)}
            </p>
          </div>
        </div>
        <div className="hoursRows">
          <div className="hoursData">
            <p className="degree-size">
              <span>SENSACIÓN TÉRMICA</span> {getDegree(data.feel, selectTemp)}
            </p>
          </div>
        </div>
        <div className="hoursRows">
          <div className="hoursData">
            <p>
              <span>VIENTO</span>
              {`${arrayWind[0]} ${getVelocity(arrayWind[1], selectVelocity, false)}`}
            </p>
          </div>
        </div>
      </Slides>
    );
  });

  const arrow = (
    <ContentIcon
      fill="#555555"
      width="12px"
      height="21px"
      nameIcon="chevronUp"
    />
  );

  return (
    <Container className="hoursTable">
      <h2>Clima por hora</h2>
      <Slider
        items={slides}
        quantityPerItem={2}
        arrowLeft={arrow}
        arrowRight={arrow}
        previewNext={true}
      />
    </Container>
  );
};
